var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeglasses(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 511.997 511.997",
    xmlSpace: "preserve",
    width: "800px",
    height: "800px",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C8E7F9"
    },
    d: "M227.085,255.998c0,47.318-38.369,85.676-85.676,85.676c-47.318,0-85.697-38.358-85.697-85.676 s38.379-85.676,85.697-85.676C188.716,170.322,227.085,208.68,227.085,255.998z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C8E7F9"
    },
    d: "M457.705,255.998c0,47.318-38.358,85.676-85.676,85.676s-85.687-38.358-85.687-85.676 s38.369-85.676,85.687-85.676S457.705,208.68,457.705,255.998z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A0D9F5"
    },
    d: "M227.085,255.998c0,47.318-38.369,85.676-85.676,85.676h-0.01V170.322h0.01 C188.716,170.322,227.085,208.68,227.085,255.998z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A0D9F5"
    },
    d: "M457.705,255.998c0,47.318-38.358,85.676-85.676,85.676V170.322 C419.347,170.322,457.705,208.68,457.705,255.998z"
  })), /*#__PURE__*/React.createElement("rect", {
    y: 238.131,
    style: {
      fill: "#005C94"
    },
    width: 54.509,
    height: 31.475
  }), /*#__PURE__*/React.createElement("rect", {
    x: 458.911,
    y: 238.131,
    style: {
      fill: "#005C95"
    },
    width: 53.085,
    height: 31.475
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#005C94"
    },
    d: "M255.16,233.331c-22.842,0.849-37.59,18.615-39.196,20.638l24.649,19.571l-0.094,0.118 c1.988-2.404,8.73-8.683,15.942-8.878c5.307-0.173,11.07,3.102,17.11,9.646l23.131-21.346 C281.001,236.067,265.451,232.975,255.16,233.331z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00DDC0"
    },
    d: "M141.398,153.368c-56.593,0-102.631,46.038-102.631,102.631s46.038,102.631,102.631,102.631 s102.631-46.038,102.631-102.631S197.991,153.368,141.398,153.368z M141.398,327.154c-39.229,0-71.155-31.927-71.155-71.155 s31.927-71.155,71.155-71.155c39.239,0,71.155,31.927,71.155,71.155S180.637,327.154,141.398,327.154z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00DDC0"
    },
    d: "M372.026,358.625c-56.59,0-102.627-46.038-102.627-102.627s46.038-102.627,102.627-102.627 s102.627,46.038,102.627,102.627S428.614,358.625,372.026,358.625z M372.026,184.847c-39.234,0-71.151,31.918-71.151,71.151 s31.918,71.151,71.151,71.151s71.151-31.918,71.151-71.151S411.259,184.847,372.026,184.847z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00DDC0"
    },
    d: "M372.026,358.625c-56.59,0-102.627-46.038-102.627-102.627s46.038-102.627,102.627-102.627 s102.627,46.038,102.627,102.627S428.614,358.625,372.026,358.625z M372.026,184.847c-39.234,0-71.151,31.918-71.151,71.151 s31.918,71.151,71.151,71.151s71.151-31.918,71.151-71.151S411.259,184.847,372.026,184.847z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M112.391,262.318l-31.296-3.352c1.925-17.973,15.962-53.533,55.313-59.474l4.698,31.123 C115.666,234.455,112.422,262.039,112.391,262.318z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M343.096,262.31l0.014-0.116l-31.297-3.352c1.926-17.974,15.964-53.533,55.314-59.474l4.699,31.123 c-10.37,1.565-17.974,6.831-23.245,16.097C344.101,254.458,343.105,262.232,343.096,262.31z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00AC93"
    },
    d: "M244.029,255.998c0,56.593-46.038,102.631-102.631,102.631v-31.475 c39.239,0,71.155-31.927,71.155-71.155s-31.916-71.155-71.155-71.155v-31.475C197.991,153.368,244.029,199.406,244.029,255.998z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00AC93"
    },
    d: "M474.657,255.998c0,56.593-46.038,102.631-102.631,102.631v-31.475 c39.239,0,71.155-31.927,71.155-71.155s-31.916-71.155-71.155-71.155v-31.475C428.618,153.368,474.657,199.406,474.657,255.998z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeglasses);
export default __webpack_public_path__ + "static/media/eyeglasses.4b435a256fb5950079ad47e923c53788.svg";
export { ForwardRef as ReactComponent };